import { render, staticRenderFns } from "./AndroidDownloadView.vue?vue&type=template&id=5cd23016&scoped=true&"
import script from "./AndroidDownloadView.vue?vue&type=script&lang=js&"
export * from "./AndroidDownloadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd23016",
  null
  
)

export default component.exports